var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"width":"90px"},attrs:{"items":_vm.statusOptions,"label":"Standard","disabled":_vm.isDisabled},on:{"change":function($event){return _vm.setSellStatus($event)}},model:{value:(_vm.item.sellStatus),callback:function ($$v) {_vm.$set(_vm.item, "sellStatus", $$v)},expression:"item.sellStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }